var L = Object.defineProperty, I = Object.defineProperties;
var j = Object.getOwnPropertyDescriptors;
var x = Object.getOwnPropertySymbols;
var A = Object.prototype.hasOwnProperty, F = Object.prototype.propertyIsEnumerable;
var K = (e) => {
  throw TypeError(e);
};
var C = (e, t, s) => t in e ? L(e, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : e[t] = s, g = (e, t) => {
  for (var s in t || (t = {}))
    A.call(t, s) && C(e, s, t[s]);
  if (x)
    for (var s of x(t))
      F.call(t, s) && C(e, s, t[s]);
  return e;
}, w = (e, t) => I(e, j(t));
var E = (e, t, s) => t.has(e) || K("Cannot " + s);
var i = (e, t, s) => (E(e, t, "read from private field"), s ? s.call(e) : t.get(e)), b = (e, t, s) => t.has(e) ? K("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, s), m = (e, t, s, r) => (E(e, t, "write to private field"), r ? r.call(e, s) : t.set(e, s), s), f = (e, t, s) => (E(e, t, "access private method"), s);
import { aE as G, aF as H, aG as U, aH as J, aI as N, m as P, aJ as Q, aK as T, aL as k, q, ax as z, aM as B, aN as V } from "./define-element-XpjsV6s1.js";
import { b as W } from "./query-client-DZ5Df1It.js";
var l, c, o, n, h, M, R, D, X = (D = class extends G {
  constructor(t, s) {
    super();
    b(this, h);
    b(this, l);
    b(this, c);
    b(this, o);
    b(this, n);
    m(this, l, t), this.setOptions(s), this.bindMethods(), f(this, h, M).call(this);
  }
  bindMethods() {
    this.mutate = this.mutate.bind(this), this.reset = this.reset.bind(this);
  }
  setOptions(t) {
    var r;
    const s = this.options;
    this.options = i(this, l).defaultMutationOptions(t), H(this.options, s) || i(this, l).getMutationCache().notify({
      type: "observerOptionsUpdated",
      mutation: i(this, o),
      observer: this
    }), s != null && s.mutationKey && this.options.mutationKey && U(s.mutationKey) !== U(this.options.mutationKey) ? this.reset() : ((r = i(this, o)) == null ? void 0 : r.state.status) === "pending" && i(this, o).setOptions(this.options);
  }
  onUnsubscribe() {
    var t;
    this.hasListeners() || (t = i(this, o)) == null || t.removeObserver(this);
  }
  onMutationUpdate(t) {
    f(this, h, M).call(this), f(this, h, R).call(this, t);
  }
  getCurrentResult() {
    return i(this, c);
  }
  reset() {
    var t;
    (t = i(this, o)) == null || t.removeObserver(this), m(this, o, void 0), f(this, h, M).call(this), f(this, h, R).call(this);
  }
  mutate(t, s) {
    var r;
    return m(this, n, s), (r = i(this, o)) == null || r.removeObserver(this), m(this, o, i(this, l).getMutationCache().build(i(this, l), this.options)), i(this, o).addObserver(this), i(this, o).execute(t);
  }
}, l = new WeakMap(), c = new WeakMap(), o = new WeakMap(), n = new WeakMap(), h = new WeakSet(), M = function() {
  var s, r;
  const t = (r = (s = i(this, o)) == null ? void 0 : s.state) != null ? r : J();
  m(this, c, w(g({}, t), {
    isPending: t.status === "pending",
    isSuccess: t.status === "success",
    isError: t.status === "error",
    isIdle: t.status === "idle",
    mutate: this.mutate,
    reset: this.reset
  }));
}, R = function(t) {
  N.batch(() => {
    var s, r, d, u, v, y, S, O;
    if (i(this, n) && this.hasListeners()) {
      const a = i(this, c).variables, p = i(this, c).context;
      (t == null ? void 0 : t.type) === "success" ? ((r = (s = i(this, n)).onSuccess) == null || r.call(s, t.data, a, p), (u = (d = i(this, n)).onSettled) == null || u.call(d, t.data, null, a, p)) : (t == null ? void 0 : t.type) === "error" && ((y = (v = i(this, n)).onError) == null || y.call(v, t.error, a, p), (O = (S = i(this, n)).onSettled) == null || O.call(
        S,
        void 0,
        t.error,
        a,
        p
      ));
    }
    this.listeners.forEach((a) => {
      a(i(this, c));
    });
  });
}, D);
function $(e, t) {
  const s = W(), r = P(() => s.defaultMutationOptions(Q(e))), d = new X(s, r.value), u = T(d.getCurrentResult()), v = d.subscribe((a) => {
    k(u, a);
  }), y = (a, p) => {
    d.mutate(a, p).catch(() => {
    });
  };
  q(r, () => {
    d.setOptions(r.value);
  }), z(() => {
    v();
  });
  const O = B(u);
  return q(
    () => u.error,
    (a) => {
      if (a && V(r.value.throwOnError, [a]))
        throw a;
    }
  ), w(g({}, O), {
    mutate: y,
    mutateAsync: u.mutate,
    reset: u.reset
  });
}
export {
  $ as u
};
